import React, { useMemo, useState, useEffect } from "react"
import he from "he";
import "./VisionValuesMission.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";


const VisionValuesMission = () => {

  const [visionMissionValue, setVisionMissionValue] = useState("");
  const { page } = useSelector((state) => state.data);

    useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.vision_mission_value_section) {
        setVisionMissionValue(he.decode(page.data.vision_mission_value_section.htmlContent));
      }
    }, [page]);

  const processedContent = useMemo(() => fixImagePaths(visionMissionValue), [visionMissionValue]);
  
    return (
      <div>
        {processedContent && (
          <div className="visionMissionValue" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    );
  };
  

export default VisionValuesMission;